import { render, staticRenderFns } from "./HotelList.vue?vue&type=template&id=53a10e5d&scoped=true&"
import script from "./HotelList.vue?vue&type=script&lang=js&"
export * from "./HotelList.vue?vue&type=script&lang=js&"
import style0 from "./HotelList.vue?vue&type=style&index=0&id=53a10e5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a10e5d",
  null
  
)

export default component.exports